module.exports = __webpack_public_path__ + "media/images/emblems/Wuennewil-Flamatt-coat_of_arms-07c1af4f1d018ccdc93219c9aaa1efa8.svg";